// eslint-disable-next-line no-restricted-imports
import { getLocale } from 'next-intl/server';
import { ELanguage } from '@portals/help-center-core';
import { getRouteLocale } from '@/i18n/get-route-locale';

export const getLanguage = async (): Promise<ELanguage> => {
  return getRouteLocale(await getLocale()) as ELanguage;
};
